import React, { useEffect, useState } from "react";
import { HeroProps, SliderItems } from "./Hero.types";
import { HeroContainer, Slide, HeroGlobalStyles } from "./Hero.style";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { content } from "../../utils/styled/_variables.styled";

export const blankSpace = (src: string) => {
  return src.replace(/ /g, "%20");
};

export default function Hero({ sliderItems, id, autoplay, time }: HeroProps) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // const [isTablet, setIsTablet] = useState(window.innerWidth < sizes.tablet);
  const [isWide, setIsWide] = useState(window.innerWidth > content.desktop);

  const handleResize = () => {
    // setIsTablet(window.innerWidth < sizes.tablet);
    setIsMobile(window.innerWidth <= 768);
    setIsWide(window.innerWidth > content.desktop);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getAssetType = (asset?: string): "image" | "video" | "unknown" => {
    if (!asset) return "unknown";
    const extension = asset.split(".").pop()?.toLowerCase();
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "tiff", "svg"];
    const videoExtensions = ["mp4"];
    return extension && imageExtensions.includes(extension) ? "image" : extension && videoExtensions.includes(extension) ? "video" : "unknown";
  };

  const sliderSettings = {
    dots: true,
    arrows: false,
    swipe: true,
    initialSlide: 0,
    accessibility: true,
    focusOnSelect: true,
    slidesToShow: 1,
    afterChange: (index: number) => setCurrentSlide(index),
    autoplay: autoplay,
    autoplaySpeed: autoplay && time ? time * 1000 : undefined,
  };

  const AssetViewPort = (item: SliderItems) => {
    if (isMobile) return blankSpace(item.assetMobile || item.asset);
    // if (isTablet) return blankSpace(item.assetTablet || item.asset);
    if (isWide) return blankSpace(item.assetWide || item.asset);
    return blankSpace(item.asset);
  };

  useEffect(() => {
    if (sliderItems) {
      sliderItems.forEach((_item, index) => {
        const video = document.getElementById(`video-${index}`) as HTMLVideoElement;
        if (video) {
          currentSlide === index ? video.play() : video.pause();
        }
      });
    }
  }, [currentSlide, sliderItems]);

  const renderSlideContent = (item: SliderItems, index: number) => {
    const assetSrc = AssetViewPort(item);
    const assetType = getAssetType(assetSrc);
    const Tag = item.tag || 'h3';

    return (
      <>
        {item.assetLink ? (
          <a href={item.assetLink} target={item.assetTarget} rel="noopener noreferrer" tabIndex={-1}>
            {assetType === "image" ? (
              <img src={assetSrc} fetchPriority={index === 0 ? "high" : "auto"} alt={item.assetAlt} title={item.assetTitle} loading={index === 0 ? "eager" : "lazy"}
              />
            ) : assetType === "video" ? (
              <video
                id={`video-${index}`}
                autoPlay
                muted
                playsInline
                title={item.assetTitle}
                onEnded={(e) => {
                  e.currentTarget.currentTime = 0;
                  e.currentTarget.play();
                }}
                aria-labelledby={`slide-${index}`}
                aria-hidden={currentSlide !== index}
              >
                <source src={assetSrc} type="video/mp4" />
              </video>
            ) : null}
            {item.text && <Tag className="heading-1 hero__title" id={`slide-${index}`}>{item.text}</Tag>}
          </a>
        ) : (
          <>
            {assetType === "image" ? (
              <img src={assetSrc} fetchPriority={index === 0 ? "high" : "auto"} alt={item.assetAlt} title={item.assetTitle} loading={index === 0 ? "eager" : "lazy"}
              />
            ) : assetType === "video" ? (
              <video
                id={`video-${index}`}
                autoPlay
                muted
                playsInline
                title={item.assetTitle}
                onEnded={(e) => {
                  e.currentTarget.currentTime = 0;
                  e.currentTarget.play();
                }}
                aria-labelledby={`slide-${index}`}
                aria-hidden={currentSlide !== index}
              >
                <source src={assetSrc} type="video/mp4" />
              </video>
            ) : null}
            {item.text && <Tag className="heading-1 hero__title" id={`slide-${index}`}>{item.text}</Tag>}
          </>
        )}
      </>
    );
  };

  return (
    <>
      <HeroGlobalStyles />
      <HeroContainer id={id ? id : ""} role="region" aria-label="Hero slider">
        <div className="content">
          {sliderItems && sliderItems.length > 0 && (
            <Slider {...sliderSettings} infinite={sliderItems.length > 1 ? true : false}>
              {sliderItems.map((item: SliderItems, index: number) => (
                <Slide key={index} aria-labelledby={`slide-${index}`}>
                  {renderSlideContent(item, index)}
                </Slide>
              ))}
            </Slider>
          )}
        </div>
      </HeroContainer>
    </>
  );
}